import * as yup from 'yup'

export const schema = yup.object().shape({
  simplifiedRegister: yup.boolean(),
  endDate: yup
    .date()
    .nullable()
    .test(
      'after-date-to-send-emails',
      'O prazo deve ser igual ou posterior à data de notificação',
      function (value) {
        const { dateToSendEmails } = this.parent
        if (!value || !dateToSendEmails) return true
        return new Date(value) >= new Date(dateToSendEmails)
      },
    ),
  dateToSendEmails: yup.date().when('simplifiedRegister', {
    is: true,
    then: yup.date().nullable(),
    otherwise: yup.date().required().typeError('Precisa ser uma data válida'),
  }),
  newResponsibleEmail: yup.string().email(),
  responsibleEmails: yup.array().when('simplifiedRegister', {
    is: false,
    then: yup.array().min(1, 'Adicione ao menos um e-mail de responsável'),
    otherwise: yup.array(),
  }),
  selectedQuizTemplates: yup
    .array()
    .min(1, 'Selecione ao menos um questionário'),
})

export default schema
